import React, { useEffect } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../helpers/AssetHelpers'
import '../auth/auth.css'

const BANNER_ICONS = [
    'bi-calendar-event',
    'bi-arrow-repeat',
    'bi-bell',
    'bi-journal-text',
    'bi-chat-left',
    'bi-telephone-forward',
]

function AuthLayout() {
    useEffect(() => {
        const root = document.getElementById('root')
        const { style: bodyStyle } = document.body
        const previousOverflow = bodyStyle.overflow

        if (root) {
            root.style.height = '100vh'
            root.style.overflow = 'hidden'
        }
        bodyStyle.overflow = 'hidden'

        return () => {
            if (root) {
                root.style.height = 'auto'
                root.style.overflow = ''
            }
            bodyStyle.overflow = previousOverflow
        }
    }, [])

    const bannerBg = `linear-gradient(145deg, rgba(6, 42, 94, 0.88) 0%, rgba(13, 94, 196, 0.85) 50%, rgba(27, 132, 255, 0.9) 100%), url(${toAbsoluteUrl('media/misc/auth-bg.png')})`

    return (
        <div className="auth-page">
            <main className="auth-page__form-panel">
                <div className="auth-page__form-scroll">
                    <div className="auth-page__form-inner">
                        <Outlet />
                    </div>
                </div>

                <div className="auth-page__footer">
                    <span>© {new Date().getFullYear()} Eyeconx</span>
                    <span className="auth-page__footer-sep" aria-hidden="true">|</span>
                    <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                    <span className="auth-page__footer-sep" aria-hidden="true">|</span>
                    <Link to="/contact-us">Contact Us</Link>
                </div>
            </main>

            <aside
                className="auth-page__banner"
                style={{ backgroundImage: bannerBg }}
            >
                <div className="auth-page__banner-overlay" aria-hidden="true">
                    <span className="auth-page__orb auth-page__orb--1" />
                    <span className="auth-page__orb auth-page__orb--2" />
                    <span className="auth-page__orb auth-page__orb--3" />
                </div>
                <div className="auth-page__banner-content">
                    <h1 className="auth-page__banner-title">Welcome to Eyeconx!</h1>
                    <p className="auth-page__banner-subtitle">
                        Eyeconx enables your practice to effortlessly and instantly send reminders,
                        recalls, notifications and education to patients via e-mails, SMS and telephone.
                    </p>
                    <div className="auth-page__banner-icons">
                        {BANNER_ICONS.map((icon, index) => (
                            <span
                                key={icon}
                                className="auth-page__banner-icon"
                                style={{ '--icon-index': index }}
                            >
                                <i className={`bi ${icon}`} />
                            </span>
                        ))}
                    </div>
                </div>
            </aside>
        </div>
    )
}

export default AuthLayout
